<script setup lang="ts">
import {useModalStore} from "../../store/modal"
import {useAuthStore} from "../../store/auth";
import NotificationRow from "../global/NotificationRow.vue";

const modalStore = useModalStore()
const authStore = useAuthStore()

const type_options = []
const sort_options = []
</script>

<template>
    <div class="notifications-modal">
        <div class="notifications-modal-header">
            <button class="notifications-close-button" @click="modalStore.close()">
                <ah-icon name="cross-default" :size="18"/>
            </button>
        </div>
        <div class="notifications-modal-body">
            <div class="notifications-modal-body-heading">
                <h1>Notifications.</h1>

                <div class="notifications-modal-body-heading-actions">
                    <!--                    <button></button>-->
                    <button @click.stop="authStore.markAllNotificationsAsRead()">
                        <ah-icon name="check-all"/>
                    </button>
                    <button @click.stop="authStore.clearAll()">
                        <ah-icon name="clear-all"/>
                    </button>
                </div>
            </div>

            <div class="notifications-modal-body-content">
                <!--                <div class="notifications-modal-body-content-filters">-->
                <!--                    <brand-form-select label="Type" :options="type_options"/>-->
                <!--                    <brand-form-select label="Sort" :options="sort_options"/>-->
                <!--                </div>-->
                <div class="notifications-modal-body-content-body">
                    <div class="notifications-modal-body-content-body-items" v-if="authStore?.notifications?.length">
                        <NotificationRow v-for="n in authStore?.notifications"
                                         :id="n.id"
                                         :type="n.type"
                                         :data="n.data"
                                         :read_at="n.read_at"
                        />
                    </div>
                    <div class="notifications-modal-body-content-empty" v-else>
                        <p>You’re all caught up.</p>
                        <p>You do not have any new notifications.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.notifications-modal {
    width: 52rem;
    z-index: 1000;
    margin: 0 4rem;

    .notifications-modal-header {
        width: 100%;
        height: 7rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .notifications-close-button {
            width: 3.6rem;
            height: 3.6rem;
            background: var(--color-white-20);
            border: none;
            outline: none;
            border-radius: 50%;
            margin-right: 7.2rem;
            position: relative;

            .icon {
                fill: var(--color-white);
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 9;
                width: 1.8rem;
                height: 1.8rem;
            }

            &::after {
                content: "";
                width: 2.4rem;
                height: 2.4rem;
                display: block;
                border-radius: 50%;
                background: var(--color-red-raspberry);
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }

    .notifications-modal-body {
        width: 100%;
        height: 84.6rem;
        background: var(--color-grey-dew);
        border-radius: 2.4rem;

        .notifications-modal-body-heading {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 7.6rem;
            padding: 0 2rem;

            .notifications-modal-body-heading-actions {
                display: flex;
                gap: 1rem;

                button {
                    width: 3.6rem;
                    height: 3.6rem;
                    border-radius: 50%;
                    background: var(--color-white);
                    border: none;
                    outline: none;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    .icon {
                        fill: var(--color-hazy);
                    }

                    &:hover {
                        background: var(--color-raspberry);

                        .icon {
                            fill: var(--color-white);
                        }
                    }
                }
            }
        }

        .notifications-modal-body-content {
            width: 100%;
            height: calc(100dvh - 7.6rem);
            background: var(--color-grey-mist);
            border-radius: 2.4rem;
            padding: 2rem;

            .notifications-modal-body-content-filters {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                grid-column-gap: 1rem;
                margin-bottom: 2rem;
            }

            .notifications-modal-body-content-body {
                width: 100%;
                height: calc(100% - 8rem);
                overflow-y: auto;

                .notifications-modal-body-content-empty {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 1rem;

                    p {
                        &:first-child {
                            @include font(2.2, 2.8, black);
                        }
                    }
                }

                &-items {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                }
            }
        }
    }

    @include dark() {
        .notifications-modal-body {
            background: var(--color-darth-vader);

            &-heading {
                h1 {
                    color: var(--color-white);
                }

                &-actions {
                    button {
                        background: var(--color-darth-maul) !important;

                        .icon {
                            fill: var(--color-dew);
                        }

                        &:hover {
                            background: var(--color-raspberry) !important;
                        }
                    }
                }
            }

            &-content {
                background: var(--color-darth-sidious);
            }
        }
    }

    @include mobile() {
        width: 100%;
        margin: 0;

        .notifications-modal-header {
            .notifications-close-button {
                margin-right: 1rem;
            }
        }
    }
}
</style>
